export const APP_HOSTNAMES = {
  PASSPORT: 'app.passport.gg',
  ASIA_PASSPORT: 'app.hogasia.com',
}

export const DISCORD_LINKS = {
  PASSPORT: 'https://discord.gg/kuyMXtFp5j',
  ASIA_PASSPORT: 'https://discord.gg/kuyMXtFp5j',
}

export const HOSTS = {
  localhost: 'localhost',
  m87PassportGg: 'm87.passport.gg',
  m87DevPassportGg: 'm87-dev.passport.gg',
  appPassportGg: 'app.passport.gg',
  appHogasiaCom: 'app.hogasia.com',
}
